import { ChangeEvent, Fragment, useState } from "react";
import { toast } from "react-toastify";
import { Button, FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import { Cancel, Next } from "../../../../../../constants";
import { ModalOneData } from "../../../../../../data/formsAndTable/forms/FormLayout";
import { FirstModalProps } from "../../../../../../types/Forms";
import SecondModal from "./SecondModal";
import { useForm } from "react-hook-form";

const FirstModal: React.FC<FirstModalProps> = ({ toggle, modalOne, initialData }) => {
  const { register, handleSubmit, setValue } = useForm();
  const [modal2, setModal2] = useState(false);
  const toggle2 = () => setModal2(!modal2);
  const getValue = (event: ChangeEvent<HTMLInputElement>) => {
    let name = event.target.name;
    let value = event.target.value;
    setValue(name, value, { shouldValidate: true, shouldDirty: true });
  };

  const handleNextButton = handleSubmit(
    () => {
      if (initialData !== "") {
        toggle2();
        toggle();
      }
    },
    () => {
      toast.error("Please select a method before pressing next button");
    }
  );
  return (
    <Fragment>
      <Modal centered isOpen={modalOne} toggle={toggle}>
        <ModalHeader toggle={toggle}>{"Two-factor authentication"}</ModalHeader>
        <ModalBody>
          <div className="modal-toggle-wrapper">
            <p>{"To log into your account, you'll also need to enter your username, password, and a code that was sent to you through SMS or an app."}</p>
            <div className="authentication-options">
              <FormGroup check className="radio radio-primary ps-0">
                <ul className="radio-wrapper">
                  {ModalOneData.map((data, index) => (
                    <li key={index}>
                      <Input {...register("selectAuthenticatorMethodName", { required: true })} onChange={getValue} id={data.title} type="radio" checked={initialData === data.title} value={data.title} />
                      <Label className="mb-0" htmlFor={data.title} check>
                        <i className={`fa ${data.icon}`} />
                        <span className="d-flex flex-column">
                          <span>{data.title}</span>
                          <span>{data.description}</span>
                        </span>
                      </Label>
                    </li>
                  ))}
                </ul>
              </FormGroup>
            </div>
            <Button color="dark" className="rounded-pill w-100 mt-3" onClick={handleNextButton}>
              {Next}
            </Button>
            <Button color="transparent" className="rounded-pill w-100 pb-0 dark-toggle-btn" onClick={toggle}>
              {Cancel}
            </Button>
          </div>
        </ModalBody>
      </Modal>
      <SecondModal modal2={modal2} toggle2={toggle2} />
    </Fragment>
  );
};

export default FirstModal;
